<template>
  <q-select
    v-model="locale"
    dark
    :options="localeOptions"
    text-white
    borderless
    emit-value
    map-options
    name="langSwitch"
  />
</template>

<script setup>
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import languages from "quasar/lang/index.json";
import { AuthModule } from "@/store/modules/auth";

const appLanguages = languages.filter((lang) =>
  ["ja", "en-US"].includes(lang.isoName),
);

const localeOptions = appLanguages.map((lang) => ({
  label: lang.nativeName,
  value: lang.isoName,
}));

const { locale } = useI18n({ useScope: "global" });

watch(locale, (val) => {
  AuthModule.setDisplayLang(val);
});
</script>
